import { BehaviorSubject, Observable } from 'rxjs';
import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { catchError, finalize } from 'rxjs/operators';

import { of } from 'rxjs';
import { CalibrationBalance, CalibrationBalanceFilter } from './calibrationBalance';
import { CalibrationBalanceService } from '../services/calibrationBalance.service';

export class CalibrationBalanceDataSource implements DataSource<CalibrationBalance> {

    public data: CalibrationBalance[];

    private calibrationsSubject = new BehaviorSubject<CalibrationBalance[]>([]);
    private loadingSubject = new BehaviorSubject<boolean>(false);
    private totalSubject = new BehaviorSubject<number>(0);

    // eslint-disable-next-line @typescript-eslint/member-ordering
    public loading$ = this.loadingSubject.asObservable();
    // eslint-disable-next-line @typescript-eslint/member-ordering
    public totalItems$ = this.totalSubject.asObservable();

    constructor(private service: CalibrationBalanceService) {
        this.calibrationsSubject.subscribe(data => this.data = data);
    }

    connect(_collectionViewer: CollectionViewer): Observable<CalibrationBalance[]> {
        return this.calibrationsSubject.asObservable();
    }

    disconnect(_collectionViewer: CollectionViewer): void {
        this.calibrationsSubject.complete();
        this.loadingSubject.complete();
        this.totalSubject.complete();
    }

    loadCalibration(filter = new CalibrationBalanceFilter()): void {

        this.loadingSubject.next(true);

        this.service.getAll(filter).pipe(catchError(() => of([])), finalize(() => this.loadingSubject.next(false))
        ).subscribe(data => {
            if (data && data.content) {
                this.calibrationsSubject.next(data.content as CalibrationBalance[]);
                this.totalSubject.next(data.totalElements as number);
            } else if (data) {
                this.calibrationsSubject.next(data as CalibrationBalance[]);
                this.totalSubject.next(data.length as number);
            } else {
                this.calibrationsSubject.next([]);
                this.totalSubject.next(0);
            }
        });
    }

}
